import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33786484"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "home-menu",
  id: "menu"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"section-header text-center\" data-aos=\"fade-up\" data-aos-duration=\"800\" data-v-33786484><span class=\"section-tag\" data-v-33786484><i class=\"ri-restaurant-2-line\" data-v-33786484></i> Our Menu </span><h2 data-v-33786484>Packed With <span class=\"text-accent\" data-v-33786484>Flavor</span></h2><p class=\"section-desc\" data-v-33786484> From birria tacos to loaded bowls — every dish is crafted with 100% Zabiha halal meats and fresh, high-quality ingredients. </p></div>", 1)
const _hoisted_4 = {
  class: "menu-categories",
  "data-aos": "fade-up",
  "data-aos-duration": "800",
  "data-aos-delay": "200"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "menu-grid" }
const _hoisted_7 = ["data-aos-delay"]
const _hoisted_8 = { class: "card-image" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = {
  key: 0,
  class: "card-badge"
}
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "card-header-row" }
const _hoisted_13 = { class: "card-price" }
const _hoisted_14 = { class: "card-tags" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
          return (_openBlock(), _createElementBlock("button", {
            key: cat.id,
            class: _normalizeClass(['cat-btn', { active: _ctx.activeCategory === cat.id }]),
            onClick: ($event: any) => (_ctx.activeCategory = cat.id)
          }, _toDisplayString(cat.label), 11, _hoisted_5))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.name,
            class: "menu-card",
            "data-aos": "fade-up",
            "data-aos-duration": "800",
            "data-aos-delay": 100 * index
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("img", {
                src: item.image,
                alt: item.name
              }, null, 8, _hoisted_9),
              (item.badge)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.badge), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("h3", null, _toDisplayString(item.name), 1),
                _createElementVNode("span", _hoisted_13, _toDisplayString(item.price), 1)
              ]),
              _createElementVNode("p", null, _toDisplayString(item.description), 1),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tags, (tag) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: tag,
                    class: "tag"
                  }, _toDisplayString(tag), 1))
                }), 128))
              ])
            ])
          ], 8, _hoisted_7))
        }), 128))
      ])
    ])
  ]))
}